import styled from 'styled-components';

export const VendasContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const CardsContainer = styled.div`
  display: flex;
  gap: 24px;

  margin-top: 40px;
`;

export const FiltersContainer = styled.div`
  margin-top: 24px;

  display: grid;
  gap: 16px;
  /* auto-fit + minmax deixa os filtros quebrarem em linhas quando falta largura;
     com repeat(7, 1fr) as colunas nao encolhem abaixo do conteudo (1fr == minmax(auto, 1fr))
     e os botoes do fim vazam a direita (ex: zoom 125%) */
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  align-items: end;

  > * {
    min-width: 0;
  }
`;

export const Row = styled.tr`
  vertical-align: middle;

  td,
  svg {
    vertical-align: middle;
  }

  .confirmButton {
    margin: 0 auto;
    background: ${({ theme }) => theme.colors.succesful};
    border-radius: 4px;
    padding: 7px 8px;
    width: fit-content;

    font-weight: 600;
    color: ${({ theme }) => theme.colors.white};

    line-height: normal;
  }

  .declinedButton {
    margin: 0 auto;
    background: ${({ theme }) => theme.colors.attention};
    border-radius: 4px;
    padding: 7px 8px;
    width: fit-content;

    font-weight: 600;
    color: ${({ theme }) => theme.colors.white};

    line-height: normal;
  }
`;
